<template>
  <Col v-for="(monthLinks, month) in linksGroupedByMonth" :key="month">
    <Col gap="xs">
      <Heading2>{{ month }}</Heading2>
      <Divider />
    </Col>
    <Col>
      <ActivityCard
        v-for="link in monthLinks"
        :key="link.id"
        :link="link"
        :showType
        :activityLocations
      ></ActivityCard>
    </Col>
  </Col>
</template>

<script setup lang="ts">
import { groupBy } from "@/utils/array";
import ActivityCard from "@/views/components/activity-card/ActivityCard.vue";
import {
  linkMatchesLinkInFilter,
  linkMatchesQuery,
  linkMatchesStudyProgramInFilter,
} from "@/views/components/filters/filter-functions";
import {
  PublicActivityLocationDTO,
  PublicActivityRegistrationLinkDTO,
  PublicStudyProgramDto,
} from "lib/eduConfigurationServiceClient";
import { computed } from "vue";

const props = defineProps<{
  links: PublicActivityRegistrationLinkDTO[];
  activityLocations?: PublicActivityLocationDTO[];
  showType: boolean;
  searchQuery?: string;
  linkFilter?: PublicActivityRegistrationLinkDTO[];
  studyProgramFilter?: PublicStudyProgramDto[];
}>();

const linksByFiltered = computed(() => {
  return props.links
    .filter(linkMatchesQuery(props.searchQuery))
    .filter(linkMatchesLinkInFilter(props.linkFilter))
    .filter(linkMatchesStudyProgramInFilter(props.studyProgramFilter));
});

const linksGroupedByMonth = computed(() =>
  groupBy(linksByFiltered.value, (link) =>
    link.startDateTime.toFormat("MMMM yyyy"),
  ),
);
</script>
